import React, { useState } from "react";

import { PartnerAccountCandidateDto, PartnerDto } from "services/partners/restModels";
import { Button } from "shared/ui/Button";
import { LabeledField } from "shared/ui/LabeledField";
import { Modal } from "shared/ui/Modal";
import { TextInput } from "shared/ui/TextInput";

import { parsePercent } from "../percent";
import { DialogForm } from "../styles";
import { AccountSelect } from "./AccountSelect";

export interface PartnerFormValues {
    name: string;
    commissionPercent: number;
    accountId: number | null;
}

interface PartnerFormDialogProps {
    // null — заводим нового партнёра: только тогда нужен поиск аккаунта.
    partner: PartnerDto | null;
    saving: boolean;
    onClose: () => void;
    onSubmit: (values: PartnerFormValues) => void;
}

export const PartnerFormDialog = ({ partner, saving, onClose, onSubmit }: PartnerFormDialogProps) => {
    const [name, setName] = useState(partner?.name ?? "");
    const [percent, setPercent] = useState(partner ? String(partner.commissionPercent) : "");
    const [candidate, setCandidate] = useState<PartnerAccountCandidateDto | null>(null);

    const commissionPercent = parsePercent(percent);
    const canSubmit =
        !saving &&
        name.trim() !== "" &&
        commissionPercent !== null &&
        (partner !== null || candidate !== null);

    return (
        <Modal
            open
            onClose={onClose}
            title={partner ? "Партнёр" : "Новый партнёр"}
            maxWidth="xs"
            actions={
                <>
                    <Button variant="text" color="neutral" onClick={onClose} disabled={saving}>
                        Отмена
                    </Button>
                    <Button
                        onClick={() =>
                            onSubmit({
                                name: name.trim(),
                                commissionPercent,
                                accountId: candidate?.accountId ?? null,
                            })
                        }
                        disabled={!canSubmit}
                    >
                        {partner ? "Сохранить" : "Создать"}
                    </Button>
                </>
            }
        >
            <DialogForm>
                <LabeledField label="Название" htmlFor="partnerName">
                    <TextInput id="partnerName" value={name} onChange={setName} disabled={saving} />
                </LabeledField>

                <LabeledField
                    label="Процент вознаграждения"
                    htmlFor="partnerPercent"
                    hint="От 0 до 100. Вознаграждение считается по текущему проценту, поэтому правка меняет и прошлые периоды."
                >
                    <TextInput
                        id="partnerPercent"
                        value={percent}
                        onChange={setPercent}
                        suffix="%"
                        disabled={saving}
                    />
                </LabeledField>

                {!partner && (
                    <AccountSelect value={candidate} disabled={saving} onChange={setCandidate} />
                )}
            </DialogForm>
        </Modal>
    );
};
